import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import prodDetail from './products_details.json';
import Swiper from 'react-id-swiper';
import lessonmenuicon from '../../../images/icons/lessonmenuiconwhite.png';

// ES6 class-style
class Topics extends PreLoginSessionCheck {

	constructor(props) {
	    super(props);
	    this.state = {
	      products_details: {},
	    }
	    this.productDetails = localStorage.getItem('proDetail');
	    this.gradeID = localStorage.getItem('grade');
		this.proID = localStorage.getItem('product');
		this.url = this.gradeID+'.json';
		this.goNext = this.goNext.bind(this);
    	this.goPrev = this.goPrev.bind(this);
    	
    	this.LessonTestMaps = window.LessonTestMaps || {};
	  }

	componentDidMount() {
		var me = this;
		this.proID = localStorage.getItem('product');
	}

	getProductDetails(){
		//console.log(JSON.parse(this.productDetails));
	    if(this.productDetails != {} && this.productDetails != undefined){
	      return JSON.parse(this.productDetails);
	    }
	}

	goNext() {
	    if (this.swiper) this.swiper.slideNext()
	}
	 
	goPrev() {
	    if (this.swiper) this.swiper.slidePrev()
	}


  render() {

  	const params = {
	 	slidesPerView: 1,
	 	spaceBetween: 30,
	 	navigation: {
	        nextEl: '.swiper-button-next',
	        prevEl: '.swiper-button-prev',
	    },
	    containerClass: 'swiper-container cbse-syllabus'
    }
  	var productType = "SPL - ";
  	if(this.props.productBase == "plp"){
  		productType = "PLP - ";
  	}
  	this.proID = localStorage.getItem('product');
  	const det = JSON.parse(this.getProductDetails()[this.proID].productDetails);
  	const gradeName = this.getProductDetails()[this.proID].ClassName;
	  const topics = det[0].topics;
	 // console.log("topics  ::: ",det)
  	const topArray = [];
  	var createGroupedArray = function(arr, chunkSize) {
	    var groups = [], i;
	    for (i = 0; i < arr.length; i += chunkSize) {
	        groups.push(arr.slice(i, i + chunkSize));
	    }
	    return groups;
	}
	var groupedArr = createGroupedArray(topics, 6);
	//console.log("topic::",topics);
	//console.log("groupedArr::",groupedArr);
	let group = det[0].group;
	
	if(group){
		group = group.split(" ").join("").toLowerCase();
	}
	
	this.stitle = <h2>Topics covered as per CBSE syllabus</h2>;
  	
  	try{	  	
	  		this.stitle = <h2>Topics covered as per CBSE syllabus - {this.getProductDetails()[this.proID].ClassName}</h2>;	  	
  	}catch(e){}
  	
  	return(
  	<section className={"mtb whyhm student nomargintop "+this.props.owner}>
	<div className="container syllabus"> 
		{this.stitle}
		<div className="row">
			<div className="col-lg-5">
				<ul>
					<li><img src="../img/1.gif" alt="Geometric pattern in Algebra topic"/></li>
					<li><img src="../img/2.gif" alt="Ratio and Proportion of water and land in the world map"/></li>
					<li><img src="../img/3.gif" alt="Large Numbers represented through Abacus"/></li>
					<li><img src="../img/4.gif" alt="Dollar currency notes piling up"/></li>
					<li><img src="../img/5.gif" alt="Measurement using a weighing scale"/></li>
					<li><img src="../img/6.gif" alt="Decimal number line shown in a conical flask"/></li>
					<li><img src="../img/7.gif" alt="Nets of a solid cylinder"/></li>
					<li><img src="../img/8.gif" alt="Square and square roots"/></li>
					<li><img src="../img/9.gif" alt="Symmetry in butterfly wings"/></li>
				</ul>
			</div>
			<div className="col-lg-7">
				<Swiper className="student-slider" slidesPerView={params.slidesPerView} spaceBetween={params.spaceBetween} containerClass={params.containerClass} ref={node => {if(node) this.swiper = node.swiper} }>
					
						{groupedArr.map((j) => 
							<div className="swiper-slide" key={j}>
								<ul>
									{j.map((v) => 
										<li key={v}>{v}</li>
									)}
								</ul>
							</div>
						)}
						
				</Swiper>
				
        		
        		{(() => {
	    		       if(topics.length>6){	
	    		    	   return(
	    		    			  <div className="slider-btns cbse-syllabus">
						        		<div data-ga={productType+gradeName +" Topics covered as per CBSE syllabus - left arrow"}className="swiper-button-prev swp-prev" onClick={this.goPrev}></div>
						        		<div data-ga={productType+gradeName +" Topics covered as per CBSE syllabus - right arrow"} className="swiper-button-next swp-next" onClick={this.goNext}></div>
					        		</div>
	    		    	   );
	    		       }
	    		    })()}
        		
        		
			</div>
			
			{/* {(() => {
		       if(this.props.productBase == "selfpaced" || this.props.productBase == "cbse"){
		    	   
		    	   if(gradeName == "Class 1" || gradeName == "Class 2" || gradeName == "Class 3" || gradeName == "Class 4" || gradeName == "Class 9" || gradeName == "Class 10")
		    	   {
			    	   return(
			    			  <div className="josefin">
					        		<i>Note: {gradeName} lessons are currently flash-based and can be viewed only on Laptop/Desktop.</i>
				        	  </div>
			    	   );
					}
		       }
				})()} */}
				
				{/* {(() => {
		       if(this.props.productBase == "selfpaced"){
		    	   
		    	   if(gradeName == "Class 1" || gradeName == "Class 2" || gradeName == "Class 3" || gradeName == "Class 4")
		    	   {
			    	   return(
			    			  <div className="josefin">
					        		<i>Note: {gradeName} lessons are currently flash-based and can be viewed only on Laptop/Desktop.</i>
				        	  </div>
			    	   );
					}
		       }
		    })()} */}
			
		</div>
		
		{/* {(() => {
		       if(gradeName == "Class 9" || gradeName == "Class 10")
	    	   {
		    	   return(
		    			 <div className="text-center yellowcolor mt-20">
							 <h4><em>Term 2 topics coming soon...</em></h4> 
						</div>
		    	   );
				}
		})()} */}
		
		
		{(() => {
			   var gdname = gradeName.split(" ").join("").toLowerCase();
			   if(gradeName == "Class 1" || gradeName == "Class 2")
	    	   {
		    	   return(
		    			  <div className="text-center mt-50">
							<div className="row col-lg-9 col-sm-11 mx-auto text-left topicmapinforow">
								<div className="col-md-6 col-12 clearfix greyborderright">
									<div className="float-left pt-10">
										<div className="topicmapLessons">
											<img className="material-icons" src={lessonmenuicon} alt="Animated Lessons icon" />
										</div>
									</div>
									<div className="float-left pl-20">
										<div><strong>{this.LessonTestMaps[gdname].LessonsMapped}</strong></div>
										<div>Animated Lessons</div>										
									</div>
								</div>
								<div className="col-md-6 col-12 norightpadding">
									<div className="float-left pt-10">
										<div className="topicmaptests">
											<i className="material-icons" role="img" aria-label="Puzzles and activites icon">extension</i>
										</div>
									</div>
									<div className="float-left pl-20">
										<div><strong>{this.LessonTestMaps[gdname].SolvedExamplesGameQuiz}</strong></div>
										<div>Activities, Games and Quizzes</div>										
									</div>
								</div>
							</div>
						</div>
						
		    	   );
	    	   }
			   else if(gradeName == "Class 3" || gradeName == "Class 4")
	    	   {
		    	   return(
		    			  <div className="text-center mt-50">
							<div className="row col-lg-10 col-sm-12 mx-auto text-left topicmapinforow">
								<div className="col-md-6 col-12 clearfix greyborderright">
									<div className="float-left pt-10">
										<div className="topicmapLessons">
											<img className="material-icons" src={lessonmenuicon} alt="Animated Lessons icon" />
										</div>
									</div>
									<div className="float-left pl-20">
										<div><strong>{this.LessonTestMaps[gdname].LessonsMapped}</strong></div>
										<div>Animated Lessons</div>										
									</div>
								</div>
								<div className="col-md-6 col-12 norightpadding">
									<div className="float-left pt-10">
										<div className="topicmaptests">
											<i className="material-icons" role="img" aria-label="Puzzles and activites icon">extension</i>
										</div>
									</div>
									<div className="float-left pl-20 width85p">
										<div><strong>{this.LessonTestMaps[gdname].SolvedExamplesGameQuiz}</strong></div>
										<div>Solved Examples, Activities, and Quizzes</div>										
									</div>
								</div>
							</div>
						</div>
						
		    	   );
	    	   }
			   else{
					return(
		    			 <div className="text-center mt-50">
							<div className="row col-lg-7 col-md-8 col-12 mx-auto text-left topicmapinforow">
								<div className="col-sm-6 clearfix greyborderright">
									<div className="float-left pt-10">
										<div className="topicmapLessons">
											<img className="material-icons" src={lessonmenuicon} alt="Animated Lessons icon" />
										</div>
									</div>
									<div className="float-left pl-20">
										<div><strong>{this.LessonTestMaps[gdname].LessonsMapped}</strong></div>
										<div>Animated Lessons</div>										
									</div>
								</div>
								<div className="col-sm-6">
									<div className="float-left pt-10">
										<div className="topicmaptests">
											<i className="material-icons" role="img" aria-label="Puzzles and activites icon">assignment</i>
										</div>
									</div>
									<div className="float-left pl-20">
										<div><strong>{this.LessonTestMaps[gdname].DiagnosticTests}</strong></div>
										<div>Diagnostic Tests</div>										
									</div>
								</div>
							</div>
						</div>
		    	   );
				}
		})()}
		
		
	</div>
	</section>
  	);
  }
}

export default Topics; 



// WEBPACK FOOTER //
// ./src/prelogin/src/components/Topics.js